<template>
    <div>
        <ButtonCircle @click="openModal" :disabled="disabled" :title="'Export trim'">
            <i class="icon-upload"></i>
        </ButtonCircle>

        <ExportTrimModal v-if="displayModal"
                         :trimId="trimId"
                         @closeModal="closeModal"
                         @cancel="closeModal"
                         @exportSuccess="handleExportSuccess"
        ></ExportTrimModal>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import ButtonCircle from "../../components/ButtonCircle";
    import ExportTrimModal from "../../components/modals/ExportTrimModal";

    export default {
        name: "ExportTrim",

        components: {
            ExportTrimModal,
            ButtonCircle,
        },

        props: [
            'disabled',
        ],

        data() {
            return {
                displayModal: false,
            }
        },

        computed: {
            ...mapState('trimInfo', [
                'trimId',
            ]),

        },

        methods: {
            openModal() {
                this.displayModal = true;
            },

            closeModal() {
                this.displayModal = false;
            },

            handleExportSuccess() {
                this.closeModal();
                this.$router.push({ name: 'home' });
            },

        },

    }
</script>

<style scoped>
    button {
        margin: 0 5px;
    }
</style>